var exports = {
  "common-title-col": "xfd349460--bbad2a--common-title-col",
  "common-rate-col": "xfd349460--bbad2a--common-rate-col",
  "common-sum-col": "xfd349460--bbad2a--common-sum-col",
  "common-term-col": "xfd349460--bbad2a--common-term-col",
  "common-payment-col": "xfd349460--bbad2a--common-payment-col",
};

module.exports = exports;
